<template>
  <div class="row">

    <div class="col-12 col-md-6">

      <div class="row mt-3">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.name')}}:</span>
        <span class="col-12 col-sm-6">{{license.name}}</span>
      </div>
      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.canceled')}}:</span>
        <span v-if="license.canceled_at === null" class="col-12 col-sm-6"> {{$t('rules.labels.0')}}</span>
        <span v-else class="col-12 col-sm-6" style="color:red">{{$t('rules.labels.1') + ', ' + $t('licenses.canceled_by_date',
                    {name: license.canceled_by.name, timestamp: license.canceled_at})}}</span>
      </div>
      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.owner')}}:</span>
        <span class="col-12 col-sm-6">{{license.entity.name}}</span>
      </div>
      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.license_type')}}:</span>
        <span class="col-12 col-sm-6">{{$t(licenseTypesAdapter[license.license_type_id])}}</span>
      </div>
      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.start_date')}}:</span>
        <span class="col-12 col-sm-6">{{license.start_date}}</span>
      </div>
      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.end_date')}}:</span>
        <span class="col-12 col-sm-6">{{license.end_date}}</span>
      </div>
      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-5">{{$t('licenses.kiosk')}}:</span>
        <span @click="redirectToKiosk(license.kiosk.id)" class="col-12 col-sm-6 kiosk-link">{{license.kiosk.name}}</span>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="row align-items-center mt-3">
        <span class="simple-label col-12 col-sm-6 col-md-4">{{$t('licenses.invoice_number')}}:</span>
        <span class="col-12 col-sm-6 col-md-8"> {{license.invoice_number || 'N/A'}} </span>
      </div>

      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-6 col-md-4">{{$t('licenses.invoice_date')}}:</span>
        <span class="col-12 col-sm-6 col-md-8">{{license.invoice_date || 'N/A'}}</span>
      </div>

      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-6 col-md-4">{{$t('licenses.invoice_amount')}}:</span>
        <span class="col-12 col-sm-6 col-md-8">{{license.invoice_amount ? `${license.invoice_amount} €` : 'N/A'}}</span>
      </div>

      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-6 col-md-4">{{$t('licenses.last_payment_date')}}:</span>
        <span class="col-12 col-sm-6 col-md-8">{{latestPayment ? `${latestPayment.date} (${latestPayment.amount ? latestPayment.amount : 0} €)` : 'N/A'}}</span>
      </div>

      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-6 col-md-4">{{$t('licenses.amount_payed')}}:</span>
        <span class="col-12 col-sm-6 col-md-8">{{license.amount_payed ? `${license.amount_payed} €`: 'N/A'  }} </span>
      </div>

      <div class="row align-items-center">
        <span class="simple-label col-12 col-sm-6 col-md-4">{{$t('licenses.amount_owed')}}:</span>
        <span class="col-12 col-sm-6 col-md-8" :class="{'text-danger': amountOwed > 0, 'text-success': amountOwed == 0}">
          {{amountOwed !== null ? `${showFloat(amountOwed)} €` : 'N/A'}}
        </span>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  props: {
    license: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      licenseTypesAdapter: {
        1: 'licenses.types.standard',
        2: 'licenses.types.premium'
      },
    }
  },
  methods: {
    redirectToKiosk: function (kioskId) {
      this.$router.push({ name: `${this.leadsService.slug}licenses/kiosks/id`, params: { id: kioskId } })
    },
    showFloat: function (value, decimalPlaces = 2) {
      if (!value) {
        return 0
      } else {
        return value.toFixed(decimalPlaces)
      }
    }
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    amountOwed: function () {
      if (!this.license.invoice_amount) {
        return null
      } else {
        return this.license.invoice_amount - this.license.amount_payed
      }
    },
    latestPayment: function () {
      if (!this.license.payments.length) {
        return null
      }

      let payments = [...this.license.payments]

      payments.sort((a, b) => {
        return a.date - b.date
      })

      return payments[0]
    }
  }
}
</script>

<style scoped lang="scss">

.kiosk-link {
  color: #29c4a9;
  cursor: pointer;
}

.kiosk-link:hover{
  color: #47d9bf;
}

.medium-card {
  width: 48.75%;
}

.medium-card-right {
  margin-left: 1.25%;
}

.medium-card-left {
  margin-right: 1.25%;
}

@media screen and (max-width: 768px) {

  .medium-card {
    width: 100%;
  }

  .mardium-card-left {
    margin-left: 0;
  }

  .medium-card-right {
    margin-right: 0;
  }
}

.loading-widget {
  min-height: 60vh;
}

.simple-label {
  font-weight: bold;
  font-size: 17px;
}

.text-success {
  color: #14be33 !important;
}
</style>
